module.exports = __webpack_public_path__ + "img/completion7.9e4db538.svg";